import { render, staticRenderFns } from "./OsPreventiva.vue?vue&type=template&id=144f709a&"
import script from "./OsPreventiva.vue?vue&type=script&lang=js&"
export * from "./OsPreventiva.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports